import * as Sebrae from '@sebrae/react-core';
import * as React from 'react';

interface BackendVersionHook {
  version: string;
}

export function useBackendVersionService(): BackendVersionHook {
  const [version, setVersion] = React.useState('');
  const { backendGet } = Sebrae.useBackend();

  React.useEffect(() => {
    backendGet<BackendVersionHook>('/public/version').then((result) =>
      setVersion(result.version),
    );
  }, [backendGet]);

  return {
    version,
  };
}
